export default "__VITE_ASSET__BtlrfLBK__"